/**
 * Event Admin Menu (kebab con le azioni organizzatore sulle card/righe gara,
 * ELENCO_GARE.md § 2). Apertura/chiusura, un solo menu aperto alla volta,
 * chiusura con click fuori ed Escape (con ritorno del focus sul bottone).
 */

class EventAdminMenu {
	constructor() {
		this.menus = document.querySelectorAll(".event-admin-menu");

		if (!this.menus.length) {
			return;
		}

		this.init();
	}

	init() {
		var self = this;

		this.menus.forEach(function(menu) {
			var toggle = menu.querySelector(".event-admin-menu__toggle");

			if (!toggle) {
				return;
			}

			toggle.addEventListener("click", function(event) {
				event.stopPropagation();
				var willOpen = !menu.classList.contains("is-open");
				self.closeAll();
				if (willOpen) {
					menu.classList.add("is-open");
					toggle.setAttribute("aria-expanded", "true");
					// porta la card/riga sopra le sorelle: il dropdown altrimenti
					// resta sotto gli elementi con z-index delle righe successive
					var host = menu.closest(".event-card, .event-row");
					if (host) {
						host.classList.add("is-menu-open");
					}
				}
			});
		});

		document.addEventListener("click", function() {
			self.closeAll();
		});

		document.addEventListener("keydown", function(event) {
			if (event.key === "Escape") {
				self.closeAll(true);
			}
		});
	}

	closeAll(restoreFocus) {
		this.menus.forEach(function(menu) {
			if (menu.classList.contains("is-open")) {
				menu.classList.remove("is-open");
				var host = menu.closest(".event-card, .event-row");
				if (host) {
					host.classList.remove("is-menu-open");
				}
				var toggle = menu.querySelector(".event-admin-menu__toggle");
				if (toggle) {
					toggle.setAttribute("aria-expanded", "false");
					if (restoreFocus) {
						toggle.focus();
					}
				}
			}
		});
	}
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", function() {
		new EventAdminMenu();
	});
} else {
	new EventAdminMenu();
}

export default EventAdminMenu;
